export const moneyAmountInfoStyle = {
	wrapper: {
		display: 'flex',
		justifyContent: 'space-between',
	},
};
